import { render, staticRenderFns } from "./StockistRecord.vue?vue&type=template&id=073ec282&scoped=true"
import script from "./StockistRecord.vue?vue&type=script&lang=js"
export * from "./StockistRecord.vue?vue&type=script&lang=js"
import style0 from "./StockistRecord.vue?vue&type=style&index=0&id=073ec282&prod&scoped=true&lang=css"
import style1 from "./StockistRecord.vue?vue&type=style&index=1&id=073ec282&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073ec282",
  null
  
)

export default component.exports